import { useState } from "react";
import { apiDelete, ApiResponse } from "../../services/api.service";

export interface AccountDeleteResult {
	success: boolean;
	extra_id: number;
	deleted_records: {
		extra_event: number;
		extra_contract: number;
		extra_payroll: number;
		groups: number;
		group_member: number;
		cancellations: number;
		extra_occupation_proof: number;
		extra_work_permit_proof: number;
		event_booking_simulations: number;
		passenger: number;
		webhook_events_updated: number;
	};
	message: string;
}

export interface AccountDeleteResponse {
	message: string;
	result: AccountDeleteResult;
}

/**
 * Hook for user to delete their own account
 */
export function useAccountDelete() {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<Error | null>(null);

	const deleteMyAccount = async (): Promise<AccountDeleteResponse | null> => {
		try {
			setLoading(true);
			setError(null);

			// Get current user ID from localStorage or auth context
			const userStr = localStorage.getItem('currentUser');
			const currentUser = userStr ? JSON.parse(userStr) : null;
			const extraId = currentUser?.extraId;

			if (!extraId) {
				throw new Error('Benutzer-ID nicht gefunden. Bitte loggen Sie sich erneut ein.');
			}

			const response = await apiDelete<AccountDeleteResponse>(
				`/extras/delete-account`,
				{
					body: JSON.stringify({
						extraId: extraId,
					}),
				}
			);

			// Extract the data from the ApiResponse wrapper
			if (response && response.data) {
				return response.data;
			}
			return response as unknown as AccountDeleteResponse;
		} catch (err) {
			const error =
				err instanceof Error
					? err
					: new Error("Löschung des Accounts fehlgeschlagen");
			setError(error);
			throw error;
		} finally {
			setLoading(false);
		}
	};

	return {
		deleteMyAccount,
		loading,
		error,
	};
}
